export * from "./getDocumentPage";
